import { useMemo, useCallback } from "react";

import { IndexCell, TrafficShare } from "app/components/React/Table/cells";
import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";
import { allTrackers } from "../../../services/track/track";

const domainCellComponent = ({ value, row }) => {
    const internalLink = useMemo(() => {
        return proNavigator.href("digitalsuite_website_websiteperformance", {
            key: value,
            country: 840,
            duration: "3m",
            webSource: "Total",
            isWWW: "*",
        });
    }, [value]);

    const trackInternalLink = useCallback(() => {
        return (e) => {
            e.stopPropagation();
            allTrackers.trackEvent("Internal Link", "click", `Table/${value}`);
        };
    }, []);

    const trackExternalLink = useCallback(() => {
        return (e) => {
            e.stopPropagation();
            allTrackers.trackEvent("External Link", "click", `Table/${value}`);
        };
    }, []);

    return (
        <CoreWebsiteCell
            domain={value}
            icon={row.Favicon}
            internalLink={internalLink}
            trackInternalLink={trackInternalLink}
            trackExternalLink={trackExternalLink}
            hideTrackButton={true}
            externalLink={`http://${value}`}
        />
    );
};

const SubdomainsTableColumnsSingleConfig = [
    {
        fixed: true,
        cellComponent: IndexCell,
        headerComponent: DefaultCellHeader,
        disableHeaderCellHover: true,
        sortable: false,
        width: 65,
        visible: true,
    },
    {
        field: "Domain",
        displayName: "Domain",
        type: "string",
        format: "None",
        sortable: true,
        isSorted: false,
        sortDirection: "desc",
        groupable: false,
        cellComponent: domainCellComponent,
        headerComponent: DefaultCellHeader,
        totalCount: true,
        get tooltip() {
            return translate("analysis.content.sub.table.columns.domain.title.tooltip");
        },
        width: 500,
        visible: true,
    },
    {
        field: "Share",
        displayName: "Traffic Share",
        type: "string",
        format: "percentagesign",
        sortable: true,
        isSorted: true,
        sortDirection: "desc",
        groupable: false,
        cellComponent: TrafficShare,
        headerComponent: DefaultCellHeader,
        totalCount: false,
        get tooltip() {
            return translate("analysis.content.sub.table.columns.share.title.tooltip");
        },
        width: 300,
        visible: true,
    },
];

const SubdomainsTableColumnsCompareConfig = [
    {
        fixed: true,
        cellComponent: IndexCell,
        headerComponent: DefaultCellHeader,
        disableHeaderCellHover: true,
        sortable: false,
        width: 65,
        visible: true,
    },
    {
        field: "Domain",
        displayName: "Domain",
        type: "string",
        format: "None",
        sortable: "true",
        isSorted: "false",
        sortDirection: "desc",
        groupable: "false",
        cellComponent: domainCellComponent,
        headerComponent: DefaultCellHeader,
        totalCount: "true",
        get tooltip() {
            return translate("analysis.content.sub.table.columns.domain.title.tooltip");
        },
        width: 500,
        visible: true,
    },
    {
        field: "Share",
        displayName: "Traffic Share",
        type: "string",
        format: "percentagesign",
        sortable: "true",
        isSorted: "true",
        sortDirection: "desc",
        groupable: "false",
        cellComponent: TrafficShare,
        headerComponent: DefaultCellHeader,
        totalCount: "False",
        get tooltip() {
            return translate("analysis.content.sub.table.columns.share.title.tooltip");
        },
        width: 300,
        visible: true,
    },
];

export const subdomainsTableColumnsConfigGen = (sortbyField: string, sortDirection: string, isCompare: boolean) => {
    if (isCompare) {
        return SubdomainsTableColumnsCompareConfig.map((col, idx) => {
            if (!col.sortable) {
                return col;
            }
            return {
                ...col,
                isSorted: col.field === sortbyField,
                sortDirection: col.field === sortbyField ? sortDirection : col.sortDirection,
            };
        });
    }
    return SubdomainsTableColumnsSingleConfig.map((col, idx) => {
        if (!col.sortable) {
            return col;
        }
        return {
            ...col,
            isSorted: col.field === sortbyField,
            sortDirection: col.field === sortbyField ? sortDirection : col.sortDirection,
        };
    });
};
